import { MonetateScript } from "./script.js";
import { monetate } from "./monetate.js";
export {
  MonetateScript,
  monetate
};
//# sourceMappingURL=index.js.map
